/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Cancel_FailedInputs */

const en_tasks_cancel_failed = /** @type {(inputs: Tasks_Cancel_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel failed`)
};

const fr_tasks_cancel_failed = /** @type {(inputs: Tasks_Cancel_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulation échouée`)
};

const ms_sg2_tasks_cancel_failed = /** @type {(inputs: Tasks_Cancel_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembatalan gagal`)
};

/**
* | output |
* | --- |
* | "Cancel failed" |
*
* @param {Tasks_Cancel_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_cancel_failed = /** @type {((inputs?: Tasks_Cancel_FailedInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Cancel_FailedInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_cancel_failed(inputs)
	if (locale === "fr") return fr_tasks_cancel_failed(inputs)
	return ms_sg2_tasks_cancel_failed(inputs)
});